export function moveToTop<T>(array: T[], index: number): T[] {
	if (array.length < 2 || index <= 0 || index >= array.length) {
		return array;
	}
	const newArray = [...array];
	[newArray[index - 1], newArray[index]] = [newArray[index], newArray[index - 1]];
	return newArray;
}

export function moveToDown<T>(array: T[], index: number): T[] {
	if (array.length < 2 || index < 0 || index >= array.length - 1) {
		return array;
	}
	const newArray = [...array];
	[newArray[index], newArray[index + 1]] = [newArray[index + 1], newArray[index]];
	return newArray;
}
